import WinnersList from './WinnerList'
import WinnerDetail from './WinnerDetail'

const Winner = {
    list : WinnersList,
    show: WinnerDetail
}

export default Winner